var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    fillRule: "evenodd",
    d: "m16.79 10.29 1.42 1.42-6.21 6.2-6.21-6.2 1.42-1.42 3.79 3.8V2h2v12.09zM20 19v-4h2v4c0 1.65-1.35 3-3 3H5c-1.65 0-3-1.35-3-3v-4h2v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1",
    clipRule: "evenodd"
  })));
};
export { SvgDownload as Icon };
export default __webpack_public_path__ + "static/media/927366ae8dcb153c0febd9e4221cacb8.svg";